import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        label: 'Main',
        isTitle: true,
    },
    {
        label: 'Menu.Dashboard',
        icon: 'home',
        link: '/dashboard',
        role: 'dashboard',
    },
    {
        label: 'Menu.Gamification',
        icon: 'dollar-sign',
        link: '/dashboard/gamifications',
        role: 'dashboard',
    },
    {
        label: 'Menu.My_Biz',
        icon: 'coffee',
        link: '/my-biz',
        role: 'my_biz',
    },
    {
        label: 'Menu.Agents',
        icon: 'users',
        link: '/agent/list',
        role: 'agents',
    },
    {
        label: 'Menu.MyOrganization',
        icon: 'grid',
        link: '/my-organization',
        role: 'resources',
    },
    {
        label: 'Menu.Production',
        icon: 'list',
        role: 'production',
        subItems: [
            {
                label: 'Menu.Production_View',
                link: '/application/list',
                role: 'production',
            },
            {
                label: 'Menu.Production_Import',
                link: '/application/import',
                role: 'production_import',
            },
            {
                label: 'Menu.Production_Log',
                link: '/application/log',
                role: 'production_log',
            },
        ],
    },
    {
        label: 'Menu.My_Portal',
        icon: 'monitor',
        link: '/my-portal',
        role: 'my_portal',
    },
    {
        label: 'Menu.My_Contracting',
        icon: 'pen-tool',
        link: '/my-contracting/list',
        role: 'my_contracting',
    },
    {
        label: 'Menu.My_Payments',
        icon: 'dollar-sign',
        link: '/coming-soon',
        role: 'my_payments',
    },
    {
        label: 'Menu.Tools',
        icon: 'tool',
        link: '/coming-soon',
        role: 'tools',
    },
    {
        label: 'Menu.Training',
        icon: 'film',
        link: '/coming-soon',
        role: 'training',
    },
    {
        label: 'Menu.Events',
        icon: 'calendar',
        link: '/coming-soon',
        role: 'avents',
    },
    {
        label: 'Menu.Resources',
        icon: 'archive',
        link: '/coming-soon',
        role: 'resources',
    },
    {
        label: 'Menu.Settings',
        isTitle: true,
        role: 'setting',
    },
    {
        label: 'Menu.Users',
        icon: 'user',
        link: '/user/list',
        role: 'user_security',
    },
    {
        label: 'Menu.Permission',
        icon: 'layers',
        link: '/permission/list',
        role: 'permission_security',
    },
    {
        label: 'Menu.Document_Type',
        icon: 'file-plus',
        link: '/document-type/list',
        role: 'document_type',
    },
    {
        label: 'Menu.Market',
        icon: 'file-plus',
        link: '/market/list',
        role: 'document_type',
    },
    {
        label: 'Menu.Carriers',
        icon: 'shield',
        link: '/carrier/list',
        role: 'carrier',
    },
    {
        label: 'Menu.Organization',
        icon: 'git-pull-request',
        link: '/organization/list',
        role: 'organization',
    },
    {
        label: 'Menu.Gamification',
        icon: 'file-text',
        link: '/gamification/list',
        role: 'gamification',
    },
];
